/* eslint-disable @typescript-eslint/no-explicit-any */
import BookingsTable from "../../../components/Admin/bookings-table";

const Reservas = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
          Reservas
        </h1>
        <p className="text-gray-600 mt-2">
          Gestiona todas las reservas de la plataforma
        </p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border">
        <div className="p-4 sm:p-6 border-b">
          <h2 className="text-lg font-semibold text-gray-900">
            Gestión de Reservas
          </h2>
          <p className="text-sm text-gray-600 mt-1">
            Administra y supervisa todas las reservas realizadas
          </p>
        </div>
        <BookingsTable />
      </div>
    </div>
  );
};

export default Reservas;
